import { useState } from 'react';
import { Loader2 } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@/components/ui/dialog';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Button } from '@/components/ui/button';
import { useSimplesNacional } from '@/contexts/SimplesNacionalContext';
import { useAlterarTipoItem } from '@/services/SimplesNacional/Segregacao/hooks/useAlterarTipoItem';

const TIPOS_ITEM = [
  { id: '00', label: '00 — Mercadoria para Revenda' },
  { id: '01', label: '01 — Matéria-Prima' },
  { id: '02', label: '02 — Embalagem' },
  { id: '03', label: '03 — Produto em Processo' },
  { id: '04', label: '04 — Produto Acabado' },
  { id: '05', label: '05 — Subproduto' },
  { id: '06', label: '06 — Produto Intermediário' },
  { id: '07', label: '07 — Material de Uso e Consumo' },
  { id: '08', label: '08 — Ativo Imobilizado' },
  { id: '09', label: '09 — Serviços' },
  { id: '10', label: '10 — Outros Insumos' },
  { id: '99', label: '99 — Outras' },
];

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  produtos: string[];
  onSuccess?: () => void;
}

export function AlterarTipoItemDialog({ open, onOpenChange, produtos, onSuccess }: Props) {
  const [tipoItem, setTipoItem] = useState('');
  const { cnpjContribuinte } = useSimplesNacional();
  const { mutate, isPending } = useAlterarTipoItem();

  const handleConfirmar = () => {
    if (!tipoItem || !cnpjContribuinte) return;
    mutate(
      { CNPJ_Contribuinte: cnpjContribuinte, TipoItem: tipoItem, Produtos: produtos },
      {
        onSuccess: () => {
          onOpenChange(false);
          setTipoItem('');
          onSuccess?.();
        },
      }
    );
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Alterar Tipo Item</DialogTitle>
          <DialogDescription>
            {produtos.length} produto(s) selecionado(s). Escolha o novo Tipo Item.
          </DialogDescription>
        </DialogHeader>

        <Select value={tipoItem} onValueChange={setTipoItem}>
          <SelectTrigger>
            <SelectValue placeholder="Selecionar Tipo Item..." />
          </SelectTrigger>
          <SelectContent>
            {TIPOS_ITEM.map(t => (
              <SelectItem key={t.id} value={t.id}>
                {t.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={isPending}>
            Cancelar
          </Button>
          <Button onClick={handleConfirmar} disabled={!tipoItem || isPending}>
            {isPending ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : null}
            Confirmar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
